import { render } from "./ShoprenterSubscriptionSuccessModal.vue?vue&type=template&id=2dd7998c"
import script from "./ShoprenterSubscriptionSuccessModal.vue?vue&type=script&lang=js"
export * from "./ShoprenterSubscriptionSuccessModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/ShoprenterSubscriptionSuccessModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2dd7998c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2dd7998c', __exports__)) {
    api.reload('2dd7998c', __exports__)
  }
  
  module.hot.accept("./ShoprenterSubscriptionSuccessModal.vue?vue&type=template&id=2dd7998c", () => {
    api.rerender('2dd7998c', render)
  })

}


export default __exports__